import { useEffect, useState } from "react";
import { http } from "../lib/api";
import { ShieldCheck } from "lucide-react";

const SEC = /^(mfa_|login_|change_password|reset_password|confirm_email|request_email|central_backup)/;
const fmt = (s) => new Date(s).toLocaleString("it-IT", { timeZone: "Europe/Rome" });

// Eventi di sicurezza di Central (MFA, accessi, password/email, backup) dal registro attività.
export function SecurityAudit() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    http.get("/audit-logs").then((r) => setRows(r.data.filter((x) => SEC.test(x.action || "")).slice(0, 100))).catch(() => setRows([]));
  }, []);
  if (!rows) return null;
  return (
    <section className="card-clean p-4 mt-6" data-testid="security-audit">
      <h2 className="font-serif text-xl mb-3 flex items-center gap-2"><ShieldCheck className="w-5 h-5" /> Eventi di sicurezza di Central</h2>
      {rows.length === 0 ? <p className="text-sm text-neutral-500">Nessun evento.</p> : (
        <div className="overflow-x-auto"><table className="w-full text-xs" data-testid="security-audit-table">
          <thead><tr className="text-left text-neutral-500"><th className="py-1 pr-3">Data</th><th className="pr-3">Evento</th><th className="pr-3">Da</th><th>Dettagli</th></tr></thead>
          <tbody>{rows.map((r) => (
            <tr key={r.id} className="border-t" data-testid={`security-audit-row-${r.id}`}>
              <td className="py-1 pr-3 whitespace-nowrap">{fmt(r.timestamp)}</td><td className="pr-3 font-mono">{r.action}</td>
              <td className="pr-3">{r.user_email}</td><td className="text-neutral-600">{Object.entries(r.diff || {}).map(([k, v]) => `${k}: ${typeof v === "object" ? JSON.stringify(v) : v}`).join(" · ")}</td>
            </tr>))}</tbody>
        </table></div>
      )}
    </section>
  );
}
